import axios from "axios";
export function getRouteWithWaypoints(start, end, waypoints) {
  return new Promise((resolve, reject) => {
    axios
      .get("https://restapi.amap.com/v3/direction/driving", {
        params: {
          key: "f393d321cb4beb722adce2980b923d68",
          origin: start, // 起点经纬度
          destination: end, // 终点经纬度
          waypoints: waypoints.join("|"), // 途经点用 | 分隔
          extensions: "base", // 只返回基本结果（距离、时长）
        },
      })
      .then((response) => {
        const route = response.data.route;
        const result = route.paths[0];
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getDistanceAndDuration(start, end) {
  return new Promise((resolve, reject) => {
    axios
      .get("https://restapi.amap.com/v3/direction/driving", {
        params: {
          key: "f393d321cb4beb722adce2980b923d68",
          origin: start, // 起点经纬度
          destination: end, // 终点经纬度
          extensions: "base", // 只返回基本结果（距离、时长）
        },
      })
      .then((response) => {
        const result = response.data.route.paths[0];
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
